import { render, staticRenderFns } from "./host.vue?vue&type=template&id=3fd68464&scoped=true&"
var script = {}
import style0 from "./host.vue?vue&type=style&index=0&id=3fd68464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd68464",
  null
  
)

export default component.exports